import React from 'react';

interface ErrorDisplayProps {
  error: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error }) => {
  return (
    <div
      style={{
        color: 'red',
        padding: '10px',
        marginBottom: '15px',
        background: '#ffeeee',
        borderRadius: '4px',
      }}
    >
      {error}
    </div>
  );
};

export default ErrorDisplay;
